import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LaborManagement_ds_work_class_users_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { users?: { id?: string, displayName?: string }[], fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { UserId?: string, DisplayName?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_work_class_users_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { users?: { id?: string, displayName?: string }[], fullTextSearch?: string, $keys: string[] }): Promise<{ result?: { UserId?: string, DisplayName?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_work_class_users_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      users?: { id?: string, displayName?: string }[], fullTextSearch?: string    }) {
      return false;
    }
}
